import React from "react";

import {VoivodeshipType} from "../../vendor/helpers/VoivodeshipType";
import {MapMarker} from "./MapMarker";

interface IProps {
    regions: string[];
}

export const MapOfPolandMarkers: React.FC<IProps> = (props) => (
    <>
        {props.regions.map((region) => (
            <React.Fragment key={region}>
                {region === VoivodeshipType.DOLNOSLASKIE && <MapMarker x={27} y={88} />}

                {region === VoivodeshipType.KUJAWSKOPOMORSKIE && <MapMarker x={64} y={38} />}

                {region === VoivodeshipType.LODZKIE && <MapMarker x={79} y={75} />}

                {region === VoivodeshipType.LUBELSKIE && <MapMarker x={137} y={83} />}

                {region === VoivodeshipType.LUBUSKIE && <MapMarker x={11} y={60} />}

                {region === VoivodeshipType.MALOPOLSKIE && <MapMarker x={92} y={125} />}

                {region === VoivodeshipType.MAZOWIECKIE && <MapMarker x={107} y={53} />}

                {region === VoivodeshipType.OPOLSKIE && <MapMarker x={52} y={103} />}

                {region === VoivodeshipType.PODKARPACKIE && <MapMarker x={125} y={121} />}

                {region === VoivodeshipType.PODLASKIE && <MapMarker x={132} y={33} />}

                {region === VoivodeshipType.POMORSKIE && <MapMarker x={57} y={8} />}

                {region === VoivodeshipType.SLASKIE && <MapMarker x={71} y={105} />}

                {region === VoivodeshipType.SWIETOKRZYSKIE && <MapMarker x={100} y={100} />}

                {region === VoivodeshipType.WARMINSKOMAZURSKIE && <MapMarker x={102} y={15} />}

                {region === VoivodeshipType.WIELKOPOLSKIE && <MapMarker x={42} y={58} />}

                {region === VoivodeshipType.ZACHODNIOPOMORSKIE && <MapMarker x={18} y={24} />}
            </React.Fragment>
        ))}
    </>
);
import React from "react";

import {VoivodeshipType} from "../../vendor/helpers/VoivodeshipType";
import {MapMarker} from "./MapMarker";

interface IProps {
    regions: string[];
}

export const MapOfPolandMarkers: React.FC<IProps> = (props) => (
    <>
        {props.regions.map((region) => (
            <React.Fragment key={region}>
                {region === VoivodeshipType.DOLNOSLASKIE && <MapMarker x={27} y={88} />}

                {region === VoivodeshipType.KUJAWSKOPOMORSKIE && <MapMarker x={64} y={38} />}

                {region === VoivodeshipType.LODZKIE && <MapMarker x={79} y={75} />}

                {region === VoivodeshipType.LUBELSKIE && <MapMarker x={137} y={83} />}

                {region === VoivodeshipType.LUBUSKIE && <MapMarker x={11} y={60} />}

                {region === VoivodeshipType.MALOPOLSKIE && <MapMarker x={92} y={125} />}

                {region === VoivodeshipType.MAZOWIECKIE && <MapMarker x={107} y={53} />}

                {region === VoivodeshipType.OPOLSKIE && <MapMarker x={52} y={103} />}

                {region === VoivodeshipType.PODKARPACKIE && <MapMarker x={125} y={121} />}

                {region === VoivodeshipType.PODLASKIE && <MapMarker x={132} y={33} />}

                {region === VoivodeshipType.POMORSKIE && <MapMarker x={57} y={8} />}

                {region === VoivodeshipType.SLASKIE && <MapMarker x={71} y={105} />}

                {region === VoivodeshipType.SWIETOKRZYSKIE && <MapMarker x={100} y={100} />}

                {region === VoivodeshipType.WARMINSKOMAZURSKIE && <MapMarker x={102} y={15} />}

                {region === VoivodeshipType.WIELKOPOLSKIE && <MapMarker x={42} y={58} />}

                {region === VoivodeshipType.ZACHODNIOPOMORSKIE && <MapMarker x={18} y={24} />}
            </React.Fragment>
        ))}
    </>
);
